<template>
    <transition name="qr-fade">
        <div ref="qrContainer" class="qr-float-container" :class="{
            'is-dragging': isDragging,
            'is-left': isLeftSide,
            'is-collapsed': !isExpanded,
            'is-expanded': isExpanded
        }" :style="containerStyle">
            <!-- 拖拽手柄 -->
            <div class="drag-handle" @mousedown="onHandleMouseDown" @touchstart="onTouchStart" @click="onHandleClick">
                <div class="drag-dots">
                    <span v-for="i in 3" :key="i" class="dot"></span>
                </div>
                <span class="drag-text">{{ isExpanded ? '收起' : '微信分享' }}</span>
                <transition name="icon-fade">
                    <svg v-if="!isExpanded" class="wechat-icon" viewBox="0 0 24 24" width="16" height="16">
                        <path fill="currentColor"
                            d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 0 1 .598.082l1.584.926a.272.272 0 0 0 .14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.582.582 0 0 1-.023-.156.49.49 0 0 1 .201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-6.656-6.088V8.89c-.135-.01-.27-.027-.407-.032zm-2.53 3.274c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.97-.982zm4.844 0c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.969-.982z" />
                    </svg>
                </transition>
            </div>

            <!-- 主体内容 -->
            <div v-show="isExpanded" ref="qrContent" class="qr-content">
                <div class="qr-card" :class="{ 'is-mobile': isMobile }">
                    <div class="qr-header">
                        <div class="qr-title-wrapper">
                            <div class="wechat-avatar">
                                <svg viewBox="0 0 24 24" width="24" height="24">
                                    <path fill="#07C160"
                                        d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18z" />
                                </svg>
                            </div>
                            <div class="qr-title-text">
                                <h3 class="qr-title">微信扫码分享</h3>
                                <p class="qr-subtitle" v-if="isMobile">长按保存二维码</p>
                            </div>
                        </div>
                        <button class="close-btn" @click.stop="collapseAndSnap">
                            <svg viewBox="0 0 24 24" width="14" height="14">
                                <path fill="currentColor"
                                    d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59 7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12 5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
                            </svg>
                        </button>
                    </div>

                    <div class="qr-body" :class="{ 'is-mobile': isMobile }">
                        <div class="qr-wrapper-outer" :class="{ 'is-mobile': isMobile, 'pc-qr-wrapper-outer': !isMobile }">
                            <div class="qr-image-container" :class="{ 'is-mobile': isMobile }">
                                <img v-if="qrImageUrl" :src="qrImageUrl" class="qr-image"
                                    :class="{ 'is-mobile': isMobile }" alt="微信分享二维码" @load="onImageLoad" />
                                <div v-if="logoUrl" class="qr-logo-overlay" :class="{ 'is-mobile': isMobile }">
                                    <img :src="logoUrl" alt="logo" class="qr-logo" :class="{ 'is-mobile': isMobile }" />
                                </div>
                            </div>
                        </div>
                        <div class="qr-tips" v-if="isMobile">
                            <span class="tip-icon">📱</span>
                            <span class="tip-text">长按识别二维码</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
    name: 'QRCodeFloat',

    props: {
        logoUrl: {
            type: String,
            default: ''
        },
        qrSize: {
            type: Number,
            default: 180
        },
        qrColor: {
            type: String,
            default: '#1a1a2e'
        },
        bgColor: {
            type: String,
            default: '#ffffff'
        },
        defaultExpanded: {
            type: Boolean,
            default: false
        },
        bottomOffset: {
            type: Number,
            default: 20
        }
    },

    data() {
        return {
            isExpanded: false,
            isDragging: false,
            hasDragged: false,
            position: { x: null, y: null },
            startPos: { x: 0, y: 0 },
            dragStartTime: 0,
            isLeftSide: false,
            qrImageUrl: '',
            currentUrl: window.location.href,
            touchStartX: 0,
            touchStartY: 0,
            lastTouchX: 0,
            lastTouchY: 0,
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            resizeObserver: null,
            isInitialized: false
        }
    },

    computed: {
        isMobile() {
            return this.windowWidth < 769
        },
        
        containerStyle() {
            // 如果位置未初始化或正在初始化，使用默认右下角
            if (this.position.x === null || !this.isInitialized) {
                return {
                    right: '20px',
                    bottom: `max(${this.bottomOffset}px, env(safe-area-inset-bottom))`,
                    left: 'auto',
                    top: 'auto',
                    transition: 'none' // 初始化时无动画，避免跳动
                }
            }

            return {
                left: `${this.position.x}px`,
                top: `${this.position.y}px`,
                right: 'auto',
                bottom: 'auto'
            }
        }
    },

    watch: {
        isExpanded(val) {
            if (val) {
                this.$nextTick(() => {
                    this.generateQRImage()
                    this.ensureVisiblePosition()
                })
            }
        }
    },

    mounted() {
        this.isExpanded = this.defaultExpanded
        
        // 延迟初始化，确保微信浏览器渲染完成
        this.initWithDelay()

        // 鼠标事件
        document.addEventListener('mousemove', this.onDrag)
        document.addEventListener('mouseup', this.stopDrag)

        // 触摸事件
        document.addEventListener('touchmove', this.onTouchMove, { passive: false })
        document.addEventListener('touchend', this.stopDrag)
        document.addEventListener('touchcancel', this.stopDrag)

        // 传统 resize 事件作为后备
        window.addEventListener('resize', this.handleResize)
        window.addEventListener('orientationchange', this.handleOrientationChange)

        // 使用 ResizeObserver 监听容器尺寸变化（更可靠）
        this.setupResizeObserver()

        // 监听URL变化
        this.urlObserver = setInterval(() => {
            if (window.location.href !== this.currentUrl) {
                this.currentUrl = window.location.href
                if (this.isExpanded) {
                    this.generateQRImage()
                }
            }
        }, 1000)
        
        // 监听页面可见性变化（处理微信切换后台再回来）
        document.addEventListener('visibilitychange', this.handleVisibilityChange)
    },

    beforeDestroy() {
        document.removeEventListener('mousemove', this.onDrag)
        document.removeEventListener('mouseup', this.stopDrag)
        document.removeEventListener('touchmove', this.onTouchMove)
        document.removeEventListener('touchend', this.stopDrag)
        document.removeEventListener('touchcancel', this.stopDrag)
        window.removeEventListener('resize', this.handleResize)
        window.removeEventListener('orientationchange', this.handleOrientationChange)
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
        clearInterval(this.urlObserver)
        
        // 清理 ResizeObserver
        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
        }
    },

    methods: {
        // 延迟初始化，解决微信浏览器初始位置问题
        initWithDelay() {
            // 第一次尝试：DOM 更新后
            this.$nextTick(() => {
                setTimeout(() => {
                    this.performInitialization()
                }, 100)
            })
            
            // 第二次尝试：确保微信浏览器完全渲染
            setTimeout(() => {
                if (!this.isInitialized) {
                    this.performInitialization()
                }
            }, 500)
            
            // 第三次尝试：保险措施
            setTimeout(() => {
                if (!this.isInitialized) {
                    this.performInitialization()
                }
            }, 1000)
        },
        
        // 执行初始化
        performInitialization() {
            this.updateWindowSize()
            this.initSide()
            
            // 设置初始位置为右下角
            if (this.position.x === null) {
                const ballWidth = 56
                const ballHeight = 56
                const margin = 20
                
                this.position.x = this.windowWidth - ballWidth - margin
                this.position.y = this.windowHeight - ballHeight - margin - this.getSafeAreaBottom()
                this.isLeftSide = false
            }
            
            this.isInitialized = true
            
            if (this.isExpanded) {
                this.generateQRImage()
            }
        },

        // 设置 ResizeObserver 监听视口变化
        setupResizeObserver() {
            if ('ResizeObserver' in window) {
                // 监听 documentElement 尺寸变化
                this.resizeObserver = new ResizeObserver((entries) => {
                    for (let entry of entries) {
                        this.handleResize()
                    }
                })
                
                // 监听 html 元素
                this.resizeObserver.observe(document.documentElement)
                
                // 也监听 body
                if (document.body) {
                    this.resizeObserver.observe(document.body)
                }
            }
        },

        // 更新窗口尺寸
        updateWindowSize() {
            this.windowWidth = window.innerWidth
            this.windowHeight = window.innerHeight
        },

        // 初始化默认在哪一侧
        initSide() {
            const windowCenter = this.windowWidth / 2
            this.isLeftSide = this.windowWidth - 100 < windowCenter
        },

        // 处理页面可见性变化（微信从后台切回前台）
        handleVisibilityChange() {
            if (!document.hidden) {
                // 页面重新可见时，更新尺寸并确保位置正确
                setTimeout(() => {
                    this.handleResize()
                }, 100)
            }
        },

        // 切换展开/收起
        toggleExpand() {
            this.isExpanded = !this.isExpanded
            this.$emit('toggle', this.isExpanded)
        },

        // 鼠标按下
        onHandleMouseDown(e) {
            this.startDrag(e.clientX, e.clientY)
            e.preventDefault()
        },

        // 触摸开始
        onTouchStart(e) {
            const touch = e.touches[0]
            this.touchStartX = touch.clientX
            this.touchStartY = touch.clientY
            this.lastTouchX = touch.clientX
            this.lastTouchY = touch.clientY
            this.startDrag(touch.clientX, touch.clientY)
        },

        // 开始拖拽
        startDrag(clientX, clientY) {
            this.isDragging = true
            this.hasDragged = false
            this.dragStartTime = Date.now()

            // 获取当前位置（如果未初始化则计算）
            if (this.position.x === null) {
                const container = this.$refs.qrContainer
                if (container) {
                    const rect = container.getBoundingClientRect()
                    this.position.x = rect.left
                    this.position.y = rect.top
                }
            }

            this.startPos = {
                x: clientX - this.position.x,
                y: clientY - this.position.y
            }
        },

        // 鼠标移动
        onDrag(e) {
            if (!this.isDragging) return
            this.handleMove(e.clientX, e.clientY)
        },

        // 触摸移动
        onTouchMove(e) {
            if (!this.isDragging) return
            const touch = e.touches[0]
            this.lastTouchX = touch.clientX
            this.lastTouchY = touch.clientY
            this.handleMove(touch.clientX, touch.clientY)
            e.preventDefault()
        },

        // 处理移动
        handleMove(clientX, clientY) {
            if (!this.hasDragged) {
                const moveDistance = Math.sqrt(
                    Math.pow(clientX - this.touchStartX, 2) +
                    Math.pow(clientY - this.touchStartY, 2)
                )
                if (moveDistance > 5) {
                    this.hasDragged = true
                }
            }

            let newX = clientX - this.startPos.x
            let newY = clientY - this.startPos.y

            const container = this.$refs.qrContainer
            if (!container) return
            
            const rect = container.getBoundingClientRect()
            const margin = 10

            // 边界限制
            newX = Math.max(margin, Math.min(newX, this.windowWidth - rect.width - margin))
            newY = Math.max(margin, Math.min(newY, this.windowHeight - rect.height - margin))

            this.position.x = newX
            this.position.y = newY

            const handleWidth = this.isExpanded ? 100 : 56
            const centerX = newX + handleWidth / 2
            this.isLeftSide = centerX < this.windowWidth / 2
        },

        // 停止拖拽
        stopDrag() {
            if (!this.isDragging) return
            this.isDragging = false

            if (!this.isExpanded) {
                this.snapToSide()
            }
        },

        // 贴边到当前纵向位置的左边或右边
        snapToSide() {
            const container = this.$refs.qrContainer
            if (!container) return

            const ballWidth = 56
            const windowCenter = this.windowWidth / 2
            const centerX = this.position.x + ballWidth / 2
            
            // 计算贴边位置，确保两侧对称（都是20px）
            const targetX = centerX < windowCenter ? 20 : this.windowWidth - ballWidth - 20

            container.style.transition = 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
            this.position.x = targetX
            this.isLeftSide = centerX < windowCenter

            setTimeout(() => {
                if (container) container.style.transition = ''
            }, 300)
        },

        // 收起并贴边
        collapseAndSnap() {
            this.isExpanded = false
            this.$emit('toggle', false)

            this.$nextTick(() => {
                setTimeout(() => {
                    this.snapToSide()
                }, 100)
            })
        },

        // 确保展开时位置可见
        ensureVisiblePosition() {
            this.$nextTick(() => {
                const container = this.$refs.qrContainer
                const content = this.$refs.qrContent
                if (!container || !content) return

                const contentRect = content.getBoundingClientRect()
                let newX = this.position.x
                let newY = this.position.y

                // 如果位置未初始化
                if (newX === null) {
                    newX = this.isLeftSide ? 40 : this.windowWidth - contentRect.width - 50
                    newY = this.windowHeight - contentRect.height - 100
                }

                // 边界检查
                if (newX + contentRect.width > this.windowWidth - 20) {
                    newX = this.windowWidth - contentRect.width - 50
                }
                if (newX < 20) {
                    newX = 40
                }

                const safeBottom = this.getSafeAreaBottom()
                if (newY + contentRect.height > this.windowHeight - safeBottom - 20) {
                    newY = this.windowHeight - contentRect.height - safeBottom - 80
                }
                if (newY < 10) {
                    newY = 10
                }

                if (newX !== this.position.x || newY !== this.position.y) {
                    container.style.transition = 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                    this.position.x = newX
                    this.position.y = newY

                    setTimeout(() => {
                        container.style.transition = ''
                    }, 300)
                }
            })
        },

        // 获取底部安全区域高度
        getSafeAreaBottom() {
            if (CSS && CSS.supports && CSS.supports('padding-bottom', 'env(safe-area-inset-bottom)')) {
                const div = document.createElement('div')
                div.style.paddingBottom = 'env(safe-area-inset-bottom)'
                document.body.appendChild(div)
                const computed = window.getComputedStyle(div)
                const value = parseInt(computed.paddingBottom) || 0
                document.body.removeChild(div)
                return value > 0 ? value : 0
            }
            return 0
        },

        // 点击手柄
        onHandleClick(e) {
            if (this.hasDragged) return
            const dragDuration = Date.now() - this.dragStartTime
            if (dragDuration > 200) return

            if (this.isExpanded) {
                this.collapseAndSnap()
            } else {
                this.toggleExpand()
            }
        },

        // 生成二维码图片
        generateQRImage() {
            const tempDiv = document.createElement('div')
            tempDiv.style.position = 'absolute'
            tempDiv.style.left = '-9999px'
            document.body.appendChild(tempDiv)

            const qr = new QRCode(tempDiv, {
                text: this.currentUrl,
                width: this.qrSize,
                height: this.qrSize,
                colorDark: this.qrColor,
                colorLight: this.bgColor,
                correctLevel: QRCode.CorrectLevel.H
            })

            setTimeout(() => {
                const canvas = tempDiv.querySelector('canvas')
                if (canvas) {
                    if (this.logoUrl) {
                        this.compositeLogo(canvas, this.logoUrl, (finalCanvas) => {
                            this.qrImageUrl = finalCanvas.toDataURL('image/png')
                            document.body.removeChild(tempDiv)
                        })
                    } else {
                        this.qrImageUrl = canvas.toDataURL('image/png')
                        document.body.removeChild(tempDiv)
                    }
                }
            }, 100)
        },

        // 合成Logo到二维码
        compositeLogo(qrCanvas, logoUrl, callback) {
            const size = qrCanvas.width
            const canvas = document.createElement('canvas')
            canvas.width = size
            canvas.height = size
            const ctx = canvas.getContext('2d')

            ctx.drawImage(qrCanvas, 0, 0)

            const logoSize = size * 0.22
            const logoX = (size - logoSize) / 2
            const logoY = (size - logoSize) / 2

            ctx.fillStyle = '#ffffff'
            ctx.beginPath()
            ctx.roundRect(logoX - 2, logoY - 2, logoSize + 4, logoSize + 4, 4)
            ctx.fill()

            const logoImg = new Image()
            logoImg.crossOrigin = 'anonymous'
            logoImg.onload = () => {
                ctx.drawImage(logoImg, logoX, logoY, logoSize, logoSize)
                callback(canvas)
            }
            logoImg.onerror = () => {
                callback(qrCanvas)
            }
            logoImg.src = logoUrl
        },

        onImageLoad() {},

        // 处理窗口尺寸变化
        handleResize() {
            const oldWidth = this.windowWidth
            const oldHeight = this.windowHeight
            
            this.updateWindowSize()
            
            // 如果尺寸没有变化，不处理
            if (oldWidth === this.windowWidth && oldHeight === this.windowHeight) {
                return
            }

            // 确保小球不会超出屏幕
            this.ensureInViewport()

            setTimeout(() => {
                if (this.isExpanded) {
                    this.ensureVisiblePosition()
                } else {
                    this.snapToSide()
                }
            }, 100)
        },

        // 确保小球在视口内
        ensureInViewport() {
            const ballWidth = 56
            const ballHeight = 56
            const margin = 20

            // 如果小球被隐藏在屏幕外，将其移回可视区域
            if (this.position.x !== null) {
                // 检查右边界
                if (this.position.x > this.windowWidth - ballWidth - margin) {
                    this.position.x = this.windowWidth - ballWidth - margin
                }
                // 检查左边界
                if (this.position.x < margin) {
                    this.position.x = margin
                }
                // 检查下边界
                if (this.position.y > this.windowHeight - ballHeight - margin) {
                    this.position.y = this.windowHeight - ballHeight - margin
                }
                // 检查上边界
                if (this.position.y < margin) {
                    this.position.y = margin
                }
            }
        },

        // 处理屏幕方向变化
        handleOrientationChange() {
            setTimeout(() => {
                this.updateWindowSize()
                this.ensureInViewport()
                
                if (this.isExpanded) {
                    this.ensureVisiblePosition()
                } else {
                    this.snapToSide()
                }
            }, 300)
        }
    }
}
</script>

<style scoped>
.qr-float-container {
    position: fixed;
    z-index: 9999;
    user-select: none;
    -webkit-user-select: none;
    touch-action: none;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    will-change: transform;
}

.is-expanded.is-left.qr-float-container {
    align-items: flex-start;
}

.is-expanded:not(.is-left).qr-float-container {
    align-items: flex-end;
}

.is-collapsed .drag-handle {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    padding: 0;
    flex-direction: column;
    gap: 3px;
    box-shadow:
        0 8px 24px rgba(7, 193, 96, 0.35),
        0 0 0 4px rgba(7, 193, 96, 0.1);
}

.is-collapsed .drag-text {
    font-size: 10px;
    transform: scale(0.8);
    font-weight: 600;
    letter-spacing: 0;
}

.is-collapsed .drag-dots {
    flex-direction: column;
    gap: 3px;
}

.is-collapsed .dot {
    width: 3px;
    height: 3px;
}

.qr-content {
    margin-top: 10px;
    animation: slideIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.is-left .qr-content {
    transform-origin: top left;
    animation-name: slideInLeft;
}

:not(.is-left) .qr-content {
    transform-origin: top right;
    animation-name: slideInRight;
}

@keyframes slideInLeft {
    from {
        opacity: 0;
        transform: translateX(-20px) scale(0.9);
    }
    to {
        opacity: 1;
        transform: translateX(0) scale(1);
    }
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(20px) scale(0.9);
    }
    to {
        opacity: 1;
        transform: translateX(0) scale(1);
    }
}

.qr-card {
    width: 280px;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 20px;
    box-shadow:
        0 20px 40px -10px rgba(0, 0, 0, 0.2),
        0 0 0 1px rgba(255, 255, 255, 0.5) inset;
    overflow: hidden;
}

.qr-card.is-mobile {
    width: 45vw;
    max-width: 240px;
    min-width: 200px;
}

.drag-handle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 12px 20px;
    background: linear-gradient(135deg, #07C160 0%, #05a350 100%);
    border-radius: 50px;
    cursor: grab;
    cursor: -webkit-grab;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    color: white;
    box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
    flex-shrink: 0;
    -webkit-tap-highlight-color: transparent;
}

.drag-handle:active {
    cursor: grabbing;
    cursor: -webkit-grabbing;
    transform: scale(0.96);
}

.drag-dots {
    display: flex;
    gap: 3px;
}

.dot {
    width: 4px;
    height: 4px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    animation: pulse 2s infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.2s;
}

.dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes pulse {
    0%, 100% {
        opacity: 0.5;
        transform: scale(1);
    }
    50% {
        opacity: 1;
        transform: scale(1.3);
    }
}

.drag-text {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.5px;
    white-space: nowrap;
}

.wechat-icon {
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.qr-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 16px 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.qr-title-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}

.wechat-avatar {
    width: 36px;
    height: 36px;
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(7, 193, 96, 0.1);
}

.qr-card.is-mobile .wechat-avatar {
    width: 32px;
    height: 32px;
}

.qr-title-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.qr-title {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #1a1a2e;
    line-height: 1.2;
}

.qr-card.is-mobile .qr-title {
    font-size: 13px;
}

.qr-subtitle {
    margin: 0;
    font-size: 12px;
    color: #6b7280;
    line-height: 1.2;
}

.close-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9ca3af;
    transition: all 0.2s ease;
    -webkit-tap-highlight-color: transparent;
}

.qr-card.is-mobile .close-btn {
    width: 24px;
    height: 24px;
}

.close-btn:hover,
.close-btn:active {
    background: rgba(220, 38, 38, 0.1);
    color: #dc2626;
    transform: rotate(90deg);
}

.qr-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.qr-body.is-mobile {
    padding: 12px;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
}

.qr-wrapper-outer {
    position: relative;
    padding: 6px;
}

.pc-qr-wrapper-outer {
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
    border-radius: 16px;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.03);
}

.qr-wrapper-outer.is-mobile {
    padding: 4px;
    border-radius: 12px;
    width: 100%;
    display: flex;
    justify-content: center;
}

.qr-image-container {
    position: relative;
    width: 180px;
    height: 180px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow:
        0 4px 6px -1px rgba(0, 0, 0, 0.05),
        0 2px 4px -1px rgba(0, 0, 0, 0.03);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.qr-image-container.is-mobile {
    width: 38vw;
    height: 38vw;
    max-width: 140px;
    max-height: 140px;
    min-width: 120px;
    min-height: 120px;
    border-radius: 10px;
}

.qr-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;
    -webkit-user-drag: none;
    user-drag: none;
}

.qr-image.is-mobile {
    border-radius: 10px;
}

.qr-logo-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    background: white;
    border-radius: 10px;
    padding: 3px;
    box-shadow:
        0 8px 12px -2px rgba(0, 0, 0, 0.1),
        0 0 0 2px rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    pointer-events: none;
}

.qr-logo-overlay.is-mobile {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    padding: 2px;
}

.qr-logo {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 6px;
}

.qr-logo.is-mobile {
    border-radius: 4px;
}

.qr-tips {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    background: rgba(7, 193, 96, 0.08);
    border-radius: 20px;
    color: #059669;
    font-size: 12px;
    font-weight: 500;
}

.qr-body.is-mobile .qr-tips {
    padding: 6px 10px;
    font-size: 11px;
}

.tip-icon {
    font-size: 14px;
}

.is-dragging .drag-handle {
    background: linear-gradient(135deg, #05a350 0%, #07C160 100%);
    transform: scale(1.05);
    box-shadow: 0 8px 25px rgba(7, 193, 96, 0.5);
}

.is-dragging .qr-content {
    opacity: 0.6;
    pointer-events: none;
}

.qr-fade-enter-active,
.qr-fade-leave-active {
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.qr-fade-enter,
.qr-fade-leave-to {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
}

.icon-fade-enter-active,
.icon-fade-leave-active {
    transition: all 0.2s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
    opacity: 0;
    transform: scale(0.5);
}

@supports (padding-bottom: env(safe-area-inset-bottom)) {
    .qr-float-container {
        bottom: env(safe-area-inset-bottom);
    }
}

@supports (-webkit-touch-callout: none) {
    .qr-float-container {
        -webkit-overflow-scrolling: touch;
    }
}
</style>